import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const FixedBillForm = (props) => {
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [rateOptions, setRateOptions] = useState([])
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date

    const [formData, setFormData] = useState({
        rate_id: "",
        year: billing_date?.year,
        month: billing_date?.month,
        date: new Date().toISOString().slice(0, 10),
    })
    const {rate_id, date, year, month} = formData

    const navigate = useNavigate()

    // Load options dynamically from a remote source
    const loadOptions = async (url, query, setOptions) => {
        const params = { q: query };

        try {
            const response = await Server.get(`/options/${url}`, {params});
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const paylaod = {rate_id, year, month, date}
        addBill(paylaod)
    }
    
    // add bill
    const addBill = async (paylaod) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/un-billed/add-bill/rate', paylaod)
            toast.success(response.data.detail);
            const option = rateOptions.find(rate => rate.value === rate_id);
            const payload = {
                year: year,
                month: month,
                by: 'rate',
                name: option?.label,
                public_id: option.public_id
            }
            navigate(`/billed-rate`, { state: {data: payload}})
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else {
                toast.error(error.response?.data?.detail || 'Unkown error')
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Add Bill Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <AsyncSelectField
                                name="rate_id"
                                label="Rate"
                                value={rate_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('rates/fixed', query, setRateOptions)}
                                options={rateOptions}
                                placeholder="Start typing to search..."
                                error={errors.rate_id}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Bill Up" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default FixedBillForm
